module.exports = __webpack_public_path__ + "media/images/gateway/7-716dc02791a6676c28b4249ac8477804.png";